import styled from 'styled-components';

import { scales, InnerProps, ScaleKeys } from './toggleTypes';

const scaleKeyValues = {
  sm: {
    handleHeight: '14px',
    handleWidth: '14px',
    handleLeft: '1px',
    // handleTop: '0.6px',
    checkedLeft: 'calc(100% - 15px)',
    toggleHeight: '16px',
    toggleWidth: '28px',
  },
  // sm: {
  //   handleHeight: '16px',
  //   handleWidth: '16px',
  //   handleLeft: '2px',
  //   handleTop: '1px',
  //   checkedLeft: 'calc(100% - 18px)',
  //   toggleHeight: '20px',
  //   toggleWidth: '36px',
  // },
  md: {
    handleHeight: '20px',
    handleWidth: '20px',
    handleLeft: '3px',
    // handleTop: '1.5px',
    checkedLeft: 'calc(100% - 23px)',
    toggleHeight: '24px',
    toggleWidth: '46px',
  },
  lg: {
    handleHeight: '32px',
    handleWidth: '32px',
    handleLeft: '4px',
    // handleTop: '3px',
    checkedLeft: 'calc(100% - 36px)',
    toggleHeight: '40px',
    toggleWidth: '72px',
  },
};

export const DEFAULT_SIZE = scales.SM;

const getScale =
  (property: ScaleKeys) =>
  ({ $scale = DEFAULT_SIZE }: InnerProps) => {
    return scaleKeyValues[$scale][property];
  };

export const Handle = styled.div<InnerProps>`
  background-color: ${({ checked }) =>
    checked ? 'var(--white)' : 'var(--white)'};
  border: 1px solid
    ${({ checked }) => (checked ? 'var(--primary6)' : 'var(--black)')};
  border-radius: 50%;
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  height: ${getScale('handleHeight')};
  left: ${getScale('handleLeft')};
  position: absolute;
  /* top: $ {getScale('handleTop')}; */
  transition: left 200ms ease-in;
  width: ${getScale('handleWidth')};
  z-index: 1;
`;

export const Input = styled.input<InnerProps>`
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  opacity: 0;
  height: 100%;
  position: absolute;
  width: 100%;
  z-index: 3;

  &:checked + ${Handle} {
    left: ${getScale('checkedLeft')};
  }
`;

/* &:focus + ${Handle}, &:hover + ${Handle}:not(:disabled):not(:checked) {
  box-shadow:
      0px 0px 0px 1px #ffffff22,
      0px 0px 3px 4px #ffffff22;
 } */

export const StyledToggle = styled.div<InnerProps>`
  align-items: center;
  background-color: ${({ checked }) =>
    checked ? 'var(--main)' : 'var(--black)'};
  border-radius: 24px;
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  display: inline-flex;
  height: ${getScale('toggleHeight')};
  position: relative;
  transition: background-color 200ms;
  width: ${getScale('toggleWidth')};
`;
